import { ICellRendererParams } from 'ag-grid-enterprise';
import { formatModString } from 'helpers/formatters';
import React from 'react';
import { IAggFunc, ValueGetterParams } from 'ag-grid-enterprise';
import { IAggFuncParams, SuppressKeyboardEventParams } from 'ag-grid-enterprise';
import { PropertyColumn } from '../types/submission.type';

export const sovModCellRenderer = (data: ICellRendererParams, formater?: any) => {
    if (data.value && typeof data.value === 'object') {
        const ret = formatModString(
            formater ? formater(data.value.orig) : data.value.orig,
            formater ? formater(data.value.mod) : data.value.mod,
            true
        );
        return ret;
    }
    if (data.value !== null) {
        return formater ? formater(data.value) : data.value;
    }
    return <></>;
};

const isValueGetterFunction = (value: any): value is (params: ValueGetterParams) => any => {
    return typeof value === 'function';
};

export const sovAggFuncs: { [key: string]: IAggFunc } = {
    aggValues: (params: IAggFuncParams) => {
        let ret: { mod: string; orig: string } | string = '';
        params.values.forEach((value) => {
            const groupNode = value !== null && value !== undefined && typeof value === 'object';
            if (groupNode) {
                ret = value;
            } else {
                let newData = value;
                if (params.data && params?.colDef?.field) {
                    newData = params.data[params.colDef.field];
                } else if (
                    params.data &&
                    params?.colDef?.valueGetter &&
                    isValueGetterFunction(params.colDef.valueGetter)
                ) {
                    newData = params.colDef.valueGetter({ data: params.data } as ValueGetterParams);
                }
                if (value !== newData) {
                    ret = { orig: value, mod: newData };
                } else {
                    ret = newData;
                }
            }
        });
        return ret;
    },
};

export const getAllPropertyColumnsExcept = (exceptColumns: PropertyColumn[]): PropertyColumn[] => {
    return Object.keys(PropertyColumn)
        .filter((column: string) => !exceptColumns.includes(PropertyColumn[column]))
        .map((column) => PropertyColumn[column]);
};

export const suppressUpDownEnterForDropDowns = (params: SuppressKeyboardEventParams) => {
    const key = params.event.key;
    const KEY_UP = 'ArrowUp';
    const KEY_DOWN = 'ArrowDown';
    const KEY_ENTER = 'Enter';
    if (key === KEY_UP || key === KEY_DOWN || key === KEY_ENTER) {
        return true;
    }
    return false;
};
